import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
} from '@mui/material'
import SelectInput from '../../Common/SelectInput'
import { ReactElement, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { updateLoader } from '../../../redux/slices/loaderSlice'
import { useTranslation } from 'react-i18next'
import { IListItemValue } from '../../../interfaces/Interfaces'

interface OrgAndTemplateSelectionProps {
    onClose: () => void
    onSubmit: (orgAndTemplateData: orgAndTemplateData) => void
    handleAddProgramStep: (hasStartStep: boolean) => void //if we has program selection. need to add program step. there user will select program setp.
    isEdit: boolean // if edit, we need know wheather we need to add program step or not.
}

export interface orgAndTemplateData {
    orgId: string
    templateId: string
    templateName: string
}

// early we have org/program selection. then we giving template selection.
// now we are directly giving template selection. that too if we have one org only. if we have more orgs/programs. we are adding program step in instance.there user going to select template
const OrgAndTemplateSelection = (
    props: OrgAndTemplateSelectionProps,
): ReactElement => {
    const { t } = useTranslation()
    const { onClose, onSubmit, handleAddProgramStep, isEdit } = props
    const availableOrgList = useAppSelector(
        (state) => state.entityInstance.availableOrgList,
    )

    const dispatch = useAppDispatch()

    const [orgAndTemplate, setOrgAndTemplate] = useState<orgAndTemplateData>({
        orgId: '',
        templateId: '',
        templateName: '',
    })

    const [totalTemplates, setTotalTemplates] = useState<IListItemValue[]>([])

    const [isOpenDialog, setIsOpenDislog] = useState<boolean>(false)

    useEffect(() => {
        if (availableOrgList?.length === 1) {
            if (isEdit) {
                handleAddProgramStep(false)
            } else {
                setOrgAndTemplate((prev) => ({
                    ...prev,
                    orgId: availableOrgList[0].id,
                }))
            }
        } else if (availableOrgList?.length > 1) {
            // setIsOpenDislog(true)
            // dispatch(updateLoader(false))
            handleAddProgramStep(true) // program step is add in instance form. there user going to select org/program and template
        }
    }, [availableOrgList])

    useEffect(() => {
        const setSubTemplateDetails = () => {
            dispatch(updateLoader(true))
            const updatedTotalTemplates: IListItemValue[] =
                availableOrgList.find((i) => i.id === orgAndTemplate?.orgId)
                    ?.templates || []
            if (
                availableOrgList?.length === 1 &&
                updatedTotalTemplates?.length === 1
            ) {
                const updatedorgAndTemplateData: orgAndTemplateData = {
                    orgId: availableOrgList[0]?.id,
                    templateId: updatedTotalTemplates[0]?.id,
                    templateName: updatedTotalTemplates[0]?.name,
                }
                onSubmit(updatedorgAndTemplateData)
            } else {
                setTotalTemplates(updatedTotalTemplates)
                setOrgAndTemplate((prev) => ({
                    ...prev,
                    templateId: updatedTotalTemplates[0]?.id || '',
                    templateName: updatedTotalTemplates[0]?.name || '',
                }))
                setIsOpenDislog(true)
                dispatch(updateLoader(false))
            }
        }
        if (orgAndTemplate?.orgId && availableOrgList?.length) {
            setSubTemplateDetails()
        }
    }, [orgAndTemplate?.orgId])

    const onChangeOrganization = (id: string, value: string) => {
        setOrgAndTemplate((prev) => {
            return {
                ...prev,
                orgId: value,
            }
        })
    }

    const onChangeTemplate = (id: string, value: string) => {
        const getTemplateDetails: IListItemValue = totalTemplates.find(
            (i) => i.id === value,
        ) || { id: '', name: '' }

        if (getTemplateDetails) {
            setOrgAndTemplate((prev) => {
                return {
                    ...prev,
                    templateId: getTemplateDetails.id,
                    templateName: getTemplateDetails.name,
                }
            })
        }
    }

    const onSubmitSubTemplate = () => {
        onSubmit(orgAndTemplate)
        setIsOpenDislog(false)
        setTotalTemplates([])
    }

    const onCloseSubTemplate = () => {
        onClose()
        setIsOpenDislog(false)
        setTotalTemplates([])
    }

    return (
        <Dialog
            open={isOpenDialog}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '400px',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
        >
            <Box>
                <DialogTitle id="scroll-dialog-title" sx={{ padding: '0px' }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        padding="15px 15px 5px 15px"
                        paddingLeft="20px"
                    >
                        <Icon
                            onClick={() => onCloseSubTemplate()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                            id="org-template-close-icon"
                            aria-label={t('close') || 'Close'}
                            title={t('close') || 'Close'}
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {availableOrgList?.length > 1 ? (
                            <Box
                                sx={{
                                    width: 'calc(100%)',
                                    marginBottom: '20px',
                                }}
                            >
                                <SelectInput
                                    label={t('program')}
                                    id="subOrgList"
                                    value={orgAndTemplate?.orgId}
                                    onChange={onChangeOrganization}
                                    list={availableOrgList || []}
                                    hasEmpty={false}
                                />
                            </Box>
                        ) : (
                            <></>
                        )}
                        {totalTemplates?.length > 1 ? (
                            <Box
                                sx={{
                                    width: 'calc(100%)',
                                    marginBottom: '20px',
                                }}
                            >
                                <SelectInput
                                    label={t('type')}
                                    id="subtemplatesList"
                                    value={orgAndTemplate?.templateId}
                                    onChange={onChangeTemplate}
                                    list={totalTemplates || []}
                                    hasEmpty={false}
                                />
                            </Box>
                        ) : (
                            <></>
                        )}
                        <Box>
                            <Button
                                sx={{ marginTop: '10px' }}
                                onClick={() => onSubmitSubTemplate()}
                                variant="contained"
                                fullWidth
                                id="org-template-submit-button"
                                disabled={
                                    !orgAndTemplate?.orgId ||
                                    !orgAndTemplate?.templateId
                                }
                            >
                                {t('add')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default OrgAndTemplateSelection
